import React, { Component, PropTypes } from 'react'

import './ServiceSetup.scss'
import LocationForm from './screens/LocationForm'
import PreferencesForm from './screens/PreferencesForm'
import DateTimeForm from './screens/DateTimeForm'

class ServiceSetup extends Component {
  constructor () {
    super()

    this.steps = [
      {
        name: '¿Dónde estás?',
        component: LocationForm
      },
      {
        name: '¿Qué necesitas?',
        component: PreferencesForm
      },
      {
        name: '¿Cuándo nos vemos?',
        component: DateTimeForm
      }
    ]

    this.next = this.next.bind(this)
    this.finish = this.finish.bind(this)
  }

  componentWillMount () {
    const {
      currentStep,
      user
    } = this.props

    if (currentStep === 0) {
      if (user && user.addresses[0]) {
        this.skipLocationStep()
      }
    }
  }

  getSetup () {
    const {
      setup,
      setupHasBeenEdited,
      user
    } = this.props

    if (setupHasBeenEdited || !user) {
      return setup
    }

    const merge = (userProps = [], setupProps = {}) => {
      return userProps.reduce((acc, prop) => {
        if (prop.slug in acc) {
          acc[prop.slug] = true
        }

        return acc
      }, {...setupProps})
    }

    const skills = merge(user.skills, setup.skills)
    const preferences = merge(user.preferences, setup.preferences)

    return {
      ...setup,
      skills,
      preferences
    }
  }

  skipLocationStep () {
    const {
      user,
      shouldReturnToSearch
    } = this.props

    const setup = this.getSetup()

    const label = user.addresses[0].colony + ', ' + user.addresses[0].state
    const location = {
      lat: user.addresses[0].coordinates.latitude,
      lng: user.addresses[0].coordinates.longitude
    }

    if (label && location) {
      const data = {
        ...setup,
        location: {
          label,
          location
        }
      }

      shouldReturnToSearch ? this.finish(data) : this.next(data)
    }
  }

  next (modifiedSetup) {
    this.props.update(modifiedSetup)
    this.props.nextStep()
  }

  finish (modifiedSetup) {
    this.props.update(modifiedSetup)
    this.props.finish()
  }

  render () {
    const {
      user,
      currentStep,
      shouldReturnToSearch
    } = this.props

    const setup = this.getSetup()
    const StepComponent = this.steps[currentStep].component
    const isLastComponent = shouldReturnToSearch || currentStep >= (this.steps.length - 1)
    const handleSubmit = isLastComponent ? this.finish : this.next

    return (
      <div className='ServiceSetup'>
        <StepComponent
          user={user}
          initialValues={setup}
          onSubmit={handleSubmit} />
      </div>
    )
  }
}
ServiceSetup.displayName = 'ServiceSetupWizard'
ServiceSetup.propTypes = {
  update: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  finish: PropTypes.func.isRequired,
  currentStep: PropTypes.number,
  setup: PropTypes.object.isRequired
}
ServiceSetup.defaultProps = {
  currentStep: 0
}

export default ServiceSetup



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/ServiceSetup.js